import { Controller } from '@hotwired/stimulus'

// Resets the filter form in place and submits it once, so the list, counter and badge update through the form's
// usual Turbo submit. The link is a page load otherwise, which leads nowhere in the native app.
// Sorting stays as it is, it is no filter.
// All filterrific fields but the sorting
const FILTER_FIELD = '[name^="filterrific["]:not([name="filterrific[sorted_by]"])'

export default class extends Controller {
  reset(event) {
    event.preventDefault()

    const form = this.element.querySelector('form')
    if (!form) return

    this.clearTextFields(form)
    this.clearSelects(form)
    this.clearDateRange(form)
    form.requestSubmit()
  }

  clearTextFields(form) {
    form
      .querySelectorAll(`input${FILTER_FIELD}`)
      .forEach((input) => { input.value = '' })
  }

  // Silent clear (no change event), the single submit afterwards covers all fields
  clearSelects(form) {
    form.querySelectorAll(`select${FILTER_FIELD}`).forEach((select) => {
      if (select.tomselect) select.tomselect.clear(true)
      else select.value = ''
    })
  }

  clearDateRange(form) {
    const picker = form.querySelector('.date-range__input')?._flatpickr
    if (picker) picker.clear(false)
    form.querySelector('.date-range__clear')?.classList.add('d-none')
  }
}
